export class PreinvoiceFormUtils {
  static pickId(x: any): any {
    if (!x) return null;
    if (x.id != null) return x.id;
    if (x.uid != null) return x.uid;
    if (x.value != null) return x.value;
    return null;
  }

  static resolveSelected(list: any[], value: any): any {
    const id = PreinvoiceFormUtils.pickId(value);
    if (id == null) return null;

    if (!list) return null;
    for (let i = 0; i < list.length; i++) {
      if (list[i] && list[i].id === id) return list[i];
    }
    return null;
  }

  static findByDisplay(list: any[], display: string): any {
    if (!list || !display) return null;
    for (let i = 0; i < list.length; i++) {
      if (list[i] && list[i].display === display) return list[i];
    }
    return null;
  }

  static findById(list: any[], id: any): any {
    if (!list || id == null) return null;
    for (let i = 0; i < list.length; i++) {
      if (list[i] && list[i].id === id) return list[i];
    }
    return null;
  }
}
